import React, {
  useState,
  useRef,
  useEffect,
} from "react";
import {
  Box,
  Chip,
  Container,
  Divider,
  Stack,
  Typography,
} from "@mui/material";


import { InputYear } from "../../Components/Inputs/Input_Year.jsx";
import { set } from "lodash";

import ValueInflatable from "../../App/ValueInflatable.jsx";
import {
  CollapseStateLabel,
  CollapseAdd,
  CollapseDelete,
  CollapseAddLabel,
  CollapseDeleteLabel,
} from "../../App/CollapseButtons.jsx";
import { AddDialog } from "../../Components/AddDialog.jsx";
import {
  getOptions,
  putOptions,
  AccountUrl_get,
  AccountUrl_put,
  ftchPlus,
  CleanAvail,
} from "../../App/Account_urls.jsx";
import { InputPercentage } from "../../Components/Inputs/Input_Percentage.jsx";
import { InputMoney } from "../../Components/Inputs/Input_Money.jsx";
import { Input_label, InputName } from "../../Components/Inputs/Input_Name.jsx";
import { errorClear, errorJsonHasErrors, errorSet, errorSetPlus } from "../../Components/Inputs/Input_Fns.jsx";
import { InputSelect1, InputSelectMonth } from "../../Components/Inputs/Select.jsx";
import { InputAge } from "../../Components/Inputs/Input_Age.jsx";
import { InputCheck } from "../../Components/Inputs/Input_Check.jsx";
import { Arrayify } from "../../Functions/utils.jsx";
import { InputButtonGroup } from "../../Components/Inputs/Input_RadioButtonGroup.jsx";

var init_v = {
  Id: 0,
  Actual: false,
  Additional: false,
  UpToAge: 0,
  Value: {
    Value: 0,
    Year: 0,
    Threshold: 0,
    Type: "Never",
    Rate: 0,
  },
};
var ret_v = {
  Id: 0,
  Type: "Income",
  Rate: 0,
};

var ChildCont = {
  Id: 0,
  ChildName: "",
  Contributions: 0,
}

var ann = {
  Id: 0,
  Year: new Date().getFullYear() - 1,
  Comment: "",
  Month: "",
  BirthYear: 1970,
  Init: [init_v],
  Return: [ret_v],
  CostBasis: 0,
  Contributions: {
    Room: 0,
    Total: 0,
    Child: [],
  },

  Fees: {
    Rate: 0,
    Value: {
      Value: 0,
      Year: new Date().getFullYear() - 1,
      Threshold: 0,
      Type: "Yearly",
      Rate: 0,
    },
  },
  Margin: {
    Deductible: false,
    Rate: 0,
    ValuePercentage: 0,
    Value: {
      Value: 0,
      Year: new Date().getFullYear() - 1,
      Threshold: 0,
      Type: "Yearly",
      Rate: 0,
    },
  },
  Sell: {
    Percentage: 0,
    Value: {
      Value: 0,
      Year: new Date().getFullYear() - 1,
      Threshold: 0,
      Type: "Yearly",
      Rate: 0,
    },
  },
};

var respChild = {
  Id: 0,
  ChildName: "",
  ContribStartAge: 0,
  ContribEndAge: 17,
  ContribEndAmount: 36000,
};

const RateOfReturn = ({ avail, form, onChange, onError }) => {
  const onChange_any = (n, v) => {
    let nf = {
      ...form,
      [n]: v,
    };
    //setForm(nf);
    console.log(nf);
    onChange(nf);
  };


  const onChange_t = (e) => {
    onChange_any(e.target.name, e.target.value);
  };

  return (
    <Stack direction="row" spacing={2}>
      <InputSelect1
        label="Return Type"
        value={form.Type}
        disabled={avail.Returns.length === 1}
        onChange={onChange_t}
        name="Type"
        avail={avail.Returns}
      />

      <InputPercentage
        label="RoR % "
        name="Rate"
        percent={form.Rate}
        maxPct={25}
        onChange={onChange_t}
        onError={onError}
      />
    </Stack>
  );
};

const ValueInit = ({ avail, form, onChange, onError }) => {
  const onChange_any = (n, v) => {
    let nf = {
      ...form,
      [n]: v,
    };
    //console.log(nf);
    onChange(nf);
  };

  const onChange_nv = (e) => {
    onChange_any(e.target.name, e.target.value);
    form.Value.Value = e.target.value;
    onChange(form);
  };

  return (
    <Stack direction="row" spacing={2}>
      <Stack>
        {/* <FormControlLabel
          sx={{ mt: -4 }}
          control={
            <Checkbox
              size="small"
              checked={form.Actual}
              onChange={(e) => {
                onChange_any("Actual", e.target.checked);
              }}
            />
          }
          label="Actual"
        /> */}
        <InputCheck
          sx={{ mt: -4 }}
          value={form.Actual}
          label="Actual"
          name="Actual"
          onChange={onChange_any}
        />
        {/* <InputCheck
          sx={{ mt: -2 }}
          value={form.Additional}
          label="Additional"
          name="Additional"
          onChange={onChange_any}
        /> */}
        {/* <FormControlLabel
          sx={{ mt: -2 }}
          control={
            <Checkbox
              size="small"
              checked={form.Additional}
              onChange={(e) => {
                onChange_any("Additional", e.target.checked);
              }}
            />
          }
          label="Additional"
        /> */}
      </Stack>

      <InputMoney
        label={"Account"}
        name="Value"
        money={form.Value.Value}
        onChange={onChange_nv}
        onError={onError}
      />
    </Stack>
  );
};

export const CurrentYear = () => {
  return new Date().getFullYear()
}

const Fees = ({ avail, form, onChange, onError }) => {
  const [errors, setErrors] = useState({})

  const onChange_any = (n, v) => {
    let nf = {
      ...form,
      [n]: v,
    };
    //console.log(nf);
    onChange(nf);
  };

  const onChange_t = (e) => {
    onChange_any(e.target.name, e.target.value);
  };


  const onChangeFee = (value, uptoage, SpousePercentage) => {
    let nf = {
      ...form,
      Value: value,
    };
    onChange(nf);
  };

  const myError = (obj, i, err) => {
    errorSetPlus(onError, errors, setErrors, obj, i, err)
  }

  return (
    <>
      <Stack direction="row" spacing={2}>
        <InputPercentage
          key="form.feerate"
          label="Fee Rate % "
          name="Rate"
          maxPct={10}
          percent={form.Rate}
          onChange={onChange_t}
          onError={(e) => myError("percent", null, e)}
        />
        <ValueInflatable
          key="form.fee value"
          form={form.Value}
          onChange={onChangeFee}
          label="Fee"
          avail={avail}
          showInf={false}
          onError={(e) => myError("value", null, e)}
        />
      </Stack>
    </>
  );
};



const Margin = ({ avail, form, onChange, onError }) => {
  const [errors, setErrors] = useState({})

  const onChange_any = (n, v) => {
    let nf = {
      ...form,
      [n]: v,
    };
    //console.log(nf);
    onChange(nf);
  };

  const onChange_t = (e) => {
    onChange_any(e.target.name, e.target.value);
  };

  const onChangeMargin = (value, uptoage, SpousePercentage) => {
    let nf = {
      ...form,
      Value: value,
    };
    onChange(nf);
  };

  const myError = (obj, i, err) => {
    errorSetPlus(onError, errors, setErrors, obj, i, err)
  }

  return (
    <>
      <Stack direction="row" spacing={2}>

        <InputPercentage
          key="form.marginrate"
          label="Margin Rate"
          name="Rate"
          maxPct={30}
          width={90}
          percent={form.Rate}
          onChange={onChange_t}
          onError={(e) => myError("percent", null, e)}
        />
        <InputPercentage
          key="form.marginvaluepct"
          label="Margin Value % "
          name="ValuePercentage"
          maxPct={200}
          width={110}
          percent={form.ValuePercentage}
          onChange={onChange_t}
          tooltip="Margin Value as a % of the account value. Either use ths or the Margin Value"
          onError={(e) => myError("marginpercent", null, e)}
        />
        <InputMoney
          label="Margin"
          money={form.ValueMoney}
          name="ValueMoney"
          width={140}
          onChange={onChange_t}
          tooltip="Margin Value as a flat value. Either enter this or the Margin Value %"
          onError={(e) => myError("marginpercent", null, e)}
        />
        <Stack>
          <InputCheck
            sx={{ mt: -2 }}
            value={form.Deductible}
            onChange={onChange_any}
            name="Deductible"
            label="Deductible"
            tooltip="Is the margin interest deductible"
            onError={(e) => myError("deductible", null, e)}
          />
        </Stack>
        {/* <ValueInflatable
          key="form.margin value"
          form={form.Value}
          onChange={onChangeMargin}

          avail={avail}
          tooltip="Typical Margin Value"
          showInf={false}
          doThr={false}
          onError={(e) => myError("value", null, e)}
        /> */}


      </Stack>
    </>
  );
};

const TFFHSA = ({ form, birthYear, avail, onChange_iy, onChange_ca, onError }) => {
  const [errors, setErrors] = useState({})


  const onChange_t = (e) => {
    //onChange_any(e.target.name, e.target.value);
    onChange_iy(e.target.value);
  };
  const onChange_select = (e) => {
    onChange_ca(e.target.value);
    // here we validate on the nf since form isn't updated yet
    validate(e.target.value)
  }
  const validate = (ca) => {
    let ne = structuredClone(errors)

    let err = (ca === "") ? "Please set a closeAccount" : ""
    ne = set(ne, "CloseAccount", err)
    //console.log(ne)
    setErrors(ne)
    if (onError !== null) {
      onError(errorJsonHasErrors(ne) ? "Errors" : "")
    }

  }


  const myError = (obj, i, err) => {
    errorSetPlus(onError, errors, setErrors, obj, i, err)
  }

  // useEffect(() => {
  //   if (form.InitialYear === undefined) {
  //     form.InitialYear = birthYear + 18
  //   }
  // }, [form])


  return (
    <>
      {form !== undefined && form.InitialYear !== undefined && (
        //<Box sx={{ my: 2, p: 2, pr: 10, border: "1px solid grey" }}>
        <Stack direction="row" spacing={2}>

          <InputYear
            year={form.InitialYear}
            name="InitialYear"
            label="Initial Year"
            birthYear={birthYear}
            minAge={birthYear >= 2005 ? 18 : 2023 - birthYear}
            maxAge={70}
            onChange={onChange_t}
            onError={(e) => myError("year", null, e)}
          />
          <InputSelect1
            label="Close Account"
            name="CloseAccount"
            value={form.CloseAccount}
            avail={avail.TFFHSA_Close}
            errors={errors}
            onChange={onChange_select}


          />
        </Stack>
        //</Box>
      )}
    </>
  );
};


const RESPChild = ({ form, avail, onChange, c_errors, onError }) => {
  const [errors, setErrors] = useState({})

  const onChange_any = (n, v) => {
    let nf = {
      ...form,
      [n]: v,
    };
    console.log(nf)
    onChange(nf)
  }


  const onChange_t = (e) => {
    //onChange_any(e.target.name, e.target.value);
    onChange_any(e.target.name, e.target.value);
  };
  const onChange_select = (e) => {
    console.log(e)
    onChange_any(e.target.name, e.target.value);
    // here we validate on the nf since form isn't updated yet
    validate(e.target.value)
  }
  const validate = (ca) => {
    // let ne = structuredClone(errors)

    // let err = (ca === "") ? "Please set a closeAccount" : ""
    // ne = set(ne, "CloseAccount", err)
    // //console.log(ne)
    // setErrors(ne)
    // if (onError !== null) {
    //   onError(errorJsonHasErrors(ne) ? "Errors" : "")
    // }

  }

  const myError = (obj, i, err) => {
    errorSetPlus(onError, errors, setErrors, obj, i, err)
  }

  return (
    <Stack direction="row" spacing={2}>
      <InputSelect1
        label="Child"
        name="ChildName"
        value={form.ChildName}
        avail={avail.Children}
        minWidth={160}
        maxWidth={220}
        errors={c_errors}
        onChange={onChange_select}


      />
      <InputAge
        age={form.ContribStartAge}
        name="ContribStartAge"
        label="Start Age"
        min={0}
        max={17}
        width={80}
        onChange={onChange_t}
        tooltip="The age for the child which you will (or did) start contributions for this child in this account. "
        onError={(e) => myError("startage", null, e)}
      />
      <InputAge
        age={form.ContribEndAge}
        name="ContribEndAge"
        label="End Age"
        min={0}
        max={17}
        width={80}
        onChange={onChange_t}
        tooltip="The age for the child which you will (or did) end contributions for this child in this account. "
        onError={(e) => myError("endage", null, e)}
      />
      <InputMoney
        money={form.ContribEndAmount}
        name="ContribEndAmount"
        label="End Amount"
        min={0}
        max={50000}
        width={80}
        onChange={onChange_t}
        tooltip="The value in contributions where you will (or did) end contributions for this child in this account. "
        onError={(e) => myError("endamount", null, e)}
      />

    </Stack>

  )
}



const RESP = ({ form, birthYear, avail, onChange_ch, onChange_ca, onChange_iy, onError }) => {


  const [errors, setErrors] = useState({})


  // const onChange_t = (e) => {
  //   //onChange_any(e.target.name, e.target.value);
  //   onChange(e.target.name, e.target.value);
  // };
  const onChange_t = (e) => {
    //onChange_any(e.target.name, e.target.value);
    onChange_iy(e.target.value);
  };
  const onChange_select = (e) => {
    onChange_ca(e.target.value);
    // here we validate on the nf since form isn't updated yet
    validate_ca(e.target.value)
  }
  const validate_ca = (ca) => {
    let ne = structuredClone(errors)

    let err = (ca === "") ? "Please set a closeAccount" : ""
    ne = set(ne, "CloseAccount", err)
    //console.log(ne)
    setErrors(ne)
    if (onError !== null) {
      onError(errorJsonHasErrors(ne) ? "Errors" : "")
    }

  }
  const onAddChild = () => {
    let n_ret = structuredClone(respChild);
    let json = [];
    if (form.RESPChildren) {
      json = form.RESPChildren.slice();
      n_ret.Id = Math.max(...form.RESPChildren.map((o) => o.Id), 0) + 1;
    }
    // console.log(n_ret);
    json.push(n_ret);
    onChange_ch(json);
  };

  const onChangeSub_i = (i, value) => {
    console.log(i)
    console.log(value)
    let json = form.RESPChildren;
    json[i] = value;
    console.log(json)
    validate(json)
    onChange_ch(json);
  };
  const validate = (json) => {
    if (json) {
      let ne = structuredClone(errors)
      let byName = [...new Map(json.map(child => [child["ChildName"], child])).values()]
      let err = ""
      if (byName.length !== json.length) {
        err = "Only use each child once"
      }
      ne = set(ne, "ChildName", err)
      setErrors(ne)
      console.log(ne)
      if (onError !== null) {
        onError(errorJsonHasErrors(ne) ? "Errors" : "")
      }
    }
  }

  const onDelete_i = (name, Id) => {
    let json = form.RESPChildren.slice();
    json = json.filter((o) => o.Id !== Id);
    onChange_ch(json);
  };

  // useEffect(() => {
  //   validate(form.RESPChildren)
  // }, [])


  const myError = (obj, i, err) => {
    errorSetPlus(onError, errors, setErrors, obj, i, err)
  }


  return (
    <>
      {form !== undefined && (
        //<Box sx={{ my: 2, p: 2, pr: 10, border: "1px solid grey" }}>
        <Stack direction="row" spacing={2}>
          <InputYear
            year={form.InitialYear}
            name="InitialYear"
            label="Initial Year"
            birthYear={birthYear}
            onChange={onChange_t}
            onError={(e) => myError("year", null, e)}
          />
          <InputSelect1
            label="Close Account"
            name="CloseAccount"
            value={form.CloseAccount}
            avail={avail.RESP_Close}
            errors={errors}
            onChange={onChange_select}
          />
          <CollapseAddLabel
            label="Child"
            onClick={onAddChild}
            tooltip="Add a child ot the RESP"
          />
          <Stack spacing={2}>
            {Arrayify(form.RESPChildren).map((v, i) => (
              <Stack key={"src-" + i} direction="row" spacing={2}>
                <RESPChild
                  avail={avail}
                  form={v}
                  c_errors={errors}
                  onChange={(v) => onChangeSub_i(i, v)}
                  onError={(e) => myError("valueI", i, e)}
                />
                <CollapseDeleteLabel
                  onClick={() => onDelete_i("Init", v.Id)}
                  tooltip="Remove this value"
                />
              </Stack>
            ))}
          </Stack>
        </Stack>
        //</Box>
      )}
    </>
  );
};






const LIRA = ({ form, avail, onChange_nv, onError }) => {
  const [errors, setErrors] = useState({})

  const myChange_nv = (n, v) => {
    onChange_nv(n, v);
    // here we validate on the nf since form isn't updated yet
    validate(n, v)
  }
  const myChange_e = (e) => {
    onChange_nv(e.target.name, e.target.value);
    // here we validate on the nf since form isn't updated yet
    validate(e.target.name, e.target.value)
  }
  const validate = (n, v) => {
    let ne = structuredClone(errors)

    if (n === "Regime") {
      let err = (v === "") ? "Please set a DCPP/LIRA Jurisdiction" : ""
      ne = set(ne, "Regime", err)
    }
    //console.log(ne)
    setErrors(ne)
    if (onError !== null) {
      onError(errorJsonHasErrors(ne) ? "Errors" : "")
    }

  }


  const myError = (obj, i, err) => {
    errorSetPlus(onError, errors, setErrors, obj, i, err)
  }

  // useEffect(() => {
  //   if (form.InitialYear === undefined) {
  //     form.InitialYear = birthYear + 18
  //   }
  // }, [form])


  return (
    <>
      {form !== undefined && (
        //<Box sx={{ my: 2, p: 2, pr: 10, border: "1px solid grey" }}>
        <Stack direction="row" spacing={2}>
          <InputSelect1
            label="Jurisdiction"
            name="Regime"
            value={form.Regime}
            avail={avail.LIRA_Regimes}
            minWidth={150}
            maxWidth={150}
            errors={errors}
            onChange={myChange_e}
          />
          {/* <Box component="fieldset" sx={{ my: 2, p: 2, pr: 10, border: "1px solid grey" }}> */}
          <Stack>
            <Divider sx={{ mt: -8 }}>
              <Chip
                label="Unlocking"
                size="small"
              />
            </Divider>

            <Stack sx={{ mt: 1.75 }} direction="row" spacing={2}>
              <InputSelect1
                label="To Account"
                name="UnlockAccount"
                value={form.UnlockAccount}
                avail={avail.UnlockAccounts}
                minWidth={150}
                maxWidth={150}
                errors={errors}
                onChange={myChange_e}
              />
              <InputPercentage
                label="%"
                name="UnlockPct"
                percent={form.UnlockPct}
                onChange={myChange_e}
                onError={(e) => myError("UnlockPct", null, e)}
              />
              <Stack  >
                <InputCheck
                  value={form.UnlockSmall}
                  onChange={myChange_nv}
                  name="UnlockSmall"
                  label="Small"
                  sx={{ mt: -3 }}
                  tooltip="Unlock a small DCPP/LIRA/LIF at conversion time"
                />
                <InputCheck
                  value={form.UnlockMaxUnused}
                  onChange={myChange_nv}
                  name="UnlockMaxUnused"
                  label="Maximum Unused"
                  sx={{ mt: -4 }}
                  tooltip="Unlock yearly the difference between the yearly maximum and any amount we already needed"
                />

              </Stack>
            </Stack>
          </Stack >
        </Stack >
        //</Box>
      )}
    </>
  );
};



const ValueYear = ({
  avail,
  form,
  minYear,
  onChange,
  children,
  accountType,
  accountTypeSpecific,
  onError,
  oneRate,
}) => {
  const [addFees, setAddFees] = useState(false);
  const [addSell, setAddSell] = useState(false);
  const [addMargin, setAddMargin] = useState(false);
  const [addNotes, setAddNotes] = useState(false);
  const [errors, setErrors] = useState({})

  useEffect(() => {
    if (form.Fees.Rate > 0 || form.Fees.Value.Value > 0) {
      setAddFees(true);
    }
    if (form.Sell.Percentage > 0 || form.Sell.Value.Value !== 0) {
      setAddSell(true);
    }
    if (form.Margin.Rate > 0 || form.Margin.ValuePercentage !== 0 || form.Margin.Value.Value !== 0) {
      setAddMargin(true);
    }
    if (form.Comment && form.Comment !== "") {
      setAddNotes(true);
    }
  }, [form]);

  const onChange_any = (n, v) => {
    // console.log("VY:change");
    // console.log(form);
    // console.log(n);
    // console.log(v);
    let nf = structuredClone(form);
    nf = set(nf, n, v)
    console.log(nf);
    onChange(nf);
  };


  const onChange_t = (e) => {
    onChange_any(e.target.name, e.target.value);
  };
  const onChange_ti = (i, e) => {
    let json = ChildList()
    json[i].Contributions = e.target.value;
    console.log(json)
    onChange_any("Contributions.Child", json);
  };
  const onChange_ct = (e) => {
    onChange_any("Contributions." + e.target.name, e.target.value);
  };

  const onChangeSub = (name, value) => {
    // console.log(name);
    // console.log(value);
    onChange_any(name, value);
  };

  const onChangeSub_i = (name, i, value) => {
    let json = form[name];
    json[i] = value;
    onChange_any(name, json);
  };

  const onDelete_i = (name, Id) => {
    let json = form[name].slice();
    json = json.filter((o) => o.Id !== Id);
    onChange_any(name, json);
  };
  const onChangeSellV = (value, uptoage, SpousePercentage) => {
    let nf = {
      ...form.Sell,
      Value: value,
    };
    onChange_any("Sell", nf);
  };

  const onChangeSellP = (e) => {
    let nf = {
      ...form.Sell,
      Percentage: e.target.value,
    };
    onChange_any("Sell", nf);
  };

  const onAdd = () => {
    let n_init = structuredClone(init_v);
    let json = [];
    if (form.Init) {
      json = form.Init.slice();
      n_init.Id = Math.max(...form.Init.map((o) => o.Id), 0) + 1;
    }
    // console.log(n_init);
    json.push(n_init);
    onChange_any("Init", json);
  };

  const onAddRate = () => {
    let n_ret = structuredClone(ret_v);
    let json = [];
    if (form.Return) {
      json = form.Return.slice();
      n_ret.Id = Math.max(...form.Return.map((o) => o.Id), 0) + 1;
    }
    n_ret.Type = avail.Returns[0];
    // console.log(n_ret);
    json.push(n_ret);
    onChange_any("Return", json);
  };

  const myError = (obj, i, err) => {
    errorSetPlus(onError, errors, setErrors, obj, i, err)
  }

  const ChildList = () => {
    let cl = []
    // console.log(form.Contributions.Child)
    for (let i = 0; i < children.length; i++) {
      if (children[i].ChildName !== "") {
        let done = false
        for (let j = 0; j < form.Contributions.Child.length; j++) {
          if (children[i].ChildName === form.Contributions.Child[j].ChildName) {
            cl.push(form.Contributions.Child[j])
            done = true
            break
          }
        }
        if (!done) {
          let x = structuredClone(ChildCont)
          x.ChildName = children[i].ChildName
          cl.push(x)
        }
      }
    }
    return cl
  }

  return (
    <Container maxWidth="true">
      <Box sx={{ my: 1, pt: 3, pb: 1, pl: 2, border: "1px solid grey" }}>
        <Stack spacing={2}>
          <Stack direction="row" spacing={2} sx={{ mt: 2 }}>
            <InputYear
              year={form.Year}
              birthYear={form.BirthYear}
              minAge={minYear > form.BirthYear ? minYear - form.BirthYear - 1 : null}
              onChange={onChange_t}
              onError={(e) => myError("year", null, e)}
            />
            {(Number(form.Year) === CurrentYear() &&
              <InputSelectMonth
                label="Month"
                name="Month"
                value={form.Month}
                onChange={onChange_t}
                errors={errors}
                tooltip="If this is the current year this is the value in this month.  Return will be prorated from this value for the rest of the year, when this is the current year."
                onError={(e) => myError("month", null, e)}
              />
            )}
            {((accountType === "Registered" &&
              accountTypeSpecific !== "RESP") ||
              (accountType === "Retirement" &&
                accountTypeSpecific === "RRSP")) && (
                <>
                  <InputMoney
                    xlabel="Avail Cont Room"
                    name="Room"
                    //sx={{ width: 80 }}
                    money={form.Contributions.Room}
                    onChange={onChange_ct}
                    onError={(e) => myError("ContRoom", null, e)}

                  />
                  <InputMoney
                    xlabel="Past Contributions"
                    name="Total"
                    //sx={{ width: 80 }}
                    money={form.Contributions.Total}
                    onChange={onChange_ct}
                    onError={(e) => myError("ContTotal", null, e)}
                  />
                </>
              )}
            {(accountType === "Registered" &&
              accountTypeSpecific === "RESP") && (
                <Stack spacing={2}>
                  {ChildList().map((child, i) => (
                    < InputMoney
                      key={"im-" + child.ChildName + ":" + i}
                      money={child.Contributions}
                      name="Contributions"
                      label={child.ChildName + " Past Contributions"}
                      min={0}
                      max={50000}
                      width={200}
                      tooltip=""
                      onChange={(e) => onChange_ti(i, e)}
                      onError={(e) => myError("contribs", null, e)}
                    />
                  ))}
                </Stack>
              )}

            <Stack>
              <Stack direction="row" spacing={2}>
                <Stack direction="row" spacing={2}>
                  {oneRate === false && (
                    <CollapseAddLabel
                      label="Rate"
                      onClick={onAddRate}
                      tooltip="Add a new investment return"
                    />
                  )}
                  <Stack spacing={2}>
                    {Arrayify(form.Return).map((d, i) => (
                      <Stack key={"sd-" + d.Id} direction="row" spacing={2}>
                        <RateOfReturn
                          avail={avail}
                          form={d}
                          onChange={(e) => onChangeSub_i("Return", i, e)}
                          onError={(e) => myError("Return", i, e)}
                        />
                        {oneRate === false && (
                          <CollapseDeleteLabel
                            onClick={() => onDelete_i("Return", d.Id)}
                            tooltip="Remove investment return"
                          />
                        )}
                      </Stack>
                    ))}
                  </Stack>
                </Stack>
                <CollapseAddLabel
                  label="Value"
                  onClick={onAdd}
                  tooltip="Add a new value to the account for the year"
                />

                <Stack direction="row" spacing={5}>
                  <Stack spacing={2}>
                    {Arrayify(form.Init).map((v, i) => (
                      <Stack key={"sd-" + v.Id} direction="row" spacing={2}>
                        <ValueInit
                          avail={avail}
                          form={v}
                          onChange={(e) => onChangeSub_i("Init", i, e)}
                          onError={(e) => myError("valueI", i, e)}
                        />
                        <CollapseDelete
                          onClick={() => onDelete_i("Init", v.Id)}
                          tooltip="Remove this value"
                        />
                      </Stack>
                    ))}
                  </Stack>
                  {accountType === "NonRegistered" && (
                    <InputMoney
                      xlabel="Cost Basis"
                      name="CostBasis"
                      money={form.CostBasis}
                      onChange={onChange_t}
                      onError={(e) => myError("costbasis", null, e)}
                    />
                  )}
                </Stack>
                <Divider orientation="vertical" flexItem />

                <Box>
                  <Stack sx={{ mt: -3 }} spacing={-2} direction="row">
                    <Stack spacing={-2}>
                      <CollapseStateLabel
                        add={addFees}
                        onClick={(e) => setAddFees(!addFees)}
                        label="Fees"
                      />
                      <CollapseStateLabel
                        add={addSell}
                        onClick={(e) => setAddSell(!addSell)}
                        label="Sell"
                      />
                    </Stack>
                    <Stack spacing={-2}>
                      {accountType === "NonRegistered" && (
                        <CollapseStateLabel
                          add={addMargin}
                          onClick={(e) => setAddMargin(!addMargin)}
                          label="Margin"
                        />
                      )}
                      <CollapseStateLabel
                        add={addNotes}
                        label="Notes"
                        onClick={setAddNotes}
                      />
                    </Stack>

                  </Stack>
                </Box>
                <Stack spacing={2} direction="row">
                  {addFees && (
                    <>
                      <Divider orientation="vertical" flexItem />

                      <Fees
                        key="Fees"
                        form={form.Fees}
                        onChange={(e) => onChangeSub("Fees", e)}
                        avail={avail}
                        onError={(e) => myError("fees", null, e)}
                      />
                    </>
                  )}

                  {addMargin && accountType === "NonRegistered" && (
                    <>
                      <Divider orientation="vertical" flexItem />

                      <Margin
                        key="Margin"
                        form={form.Margin}
                        onChange={(e) => onChangeSub("Margin", e)}
                        avail={avail}
                        onError={(e) => myError("margin", null, e)}
                      />
                    </>
                  )}

                  {addSell && (
                    <>
                      <Divider orientation="vertical" flexItem />

                      <InputPercentage
                        label="Sell %"
                        name="SellPercentage"
                        percent={form.Sell.Percentage}
                        onChange={onChangeSellP}
                        onError={(e) => myError("sell_percent", null, e)}

                      />
                      <ValueInflatable
                        form={form.Sell.Value}
                        onChange={onChangeSellV}
                        label="Sell"
                        avail={avail}
                        showInf={false}
                        onError={(e) => myError("valueSell", null, e)}

                      />
                    </>
                  )}
                </Stack>
              </Stack>
              {addNotes && (
                <Stack direction="row" spacing={2} sx={{ mx: -4 }}>
                  <Input_label
                    label="Notes"
                    name="Comment"
                    value={form.Comment}
                    maxLength={800}
                    width={800}
                    required={false}

                    onChange={onChange_t}
                    errors={errors}
                    onError={(name, e) => myError(name, null, e)}
                  />

                </Stack>
              )}
            </Stack>
          </Stack>
        </Stack>
      </Box>
    </Container>
  );
};



const AddInvestAccount = ({
  show,
  close,
  client_p,
  clientJson,
  c_callback,
  account,
  account_uuid,
  accountType,
  add,
  oneRate = false,
}) => {
  const data = useRef();
  const [form, setForm] = useState();
  const [dataset, setDataset] = useState();
  const [client, setClient] = useState(client_p);
  const [clients, setClients] = useState([client_p]);
  const [added, setAdded] = useState([false, false]);
  const [errors, setErrors] = useState({})
  const [errmsg, setErrmsg] = useState("")
  const [deleted, setDeleted] = useState(false)



  const getInputData = (client_) => {
    let url = AccountUrl_get(clientJson, "account", account, account_uuid, add, accountType);
    ftchPlus(url, getOptions)
      .then((json) => {
        if (json) {
          setAdded([false, false]);
          data.current = json;
          setForm(json);
          setClients(json.Clients);
          Update(client_);
          console.log(data.current);
        }
      })
      .catch((error) => {
        console.log(error.message);
        setErrmsg(error.message)

      });
  };

  const myClose = () => {
    data.current = null;
    setDataset(null);
    close(accountType);
  };

  const putRequest = async () => {
    let url = AccountUrl_put(
      clientJson,
      "account",
      form.DataSet[client].Name,
      form.DataSet[client].AccountUuid,
      form.DataSet[client].NameOrig,
      add
    );
    var req = putOptions;
    let post = CleanAvail(form)
    req.body = JSON.stringify(post);
    ftchPlus(url, req)
      .then((json) => {
        console.log("update completed");
        myClose();
      })
      .catch((error) => {
        console.log(error.message);
        setErrmsg(error.message)

      });
  };

  const onSubmit = () => {
    console.log("on submit");
    console.log(form);
    putRequest();
  };

  useEffect(() => {
    if (show) {
      errorClear(errors)
      setErrmsg("")
      setDeleted(false)
      getInputData(client_p);
    }
  }, [show]);

  useEffect(() => {
    let cl = client === clients[0] ? 0 : 1;
    if (add && dataset && !added[cl]) {
      onAdd();
      let x = added;
      x[cl] = true;
      setAdded(x);
    }
  }, [add, dataset]);

  const Update = (cl) => {
    setClient(cl);
    setDataset(data.current.DataSet[cl]);
  };

  const onChange_any = (subpath, any) => {
    console.log("any_change: ");
    console.log(any);
    let path = "DataSet[" + client + "]";
    if (subpath !== "") {
      path += "." + subpath;
    }

    console.log("Path: " + path);
    let nf = form;
    nf = set(nf, path, any);
    setForm(nf);
    nf = {
      ...nf,
    };
    setForm(nf);

    Update(client);
    console.log(nf);
  };

  const onChangeMe = (e, i) => {
    // console.log("SA");
    // console.log(e);
    // console.log(i);

    let path = "Annual[" + i + "]";
    onChange_any(path, e);

    let json = data.current.DataSet[client].Annual.slice();
    json = json.filter(
      (o) =>
        o.Init.length !== 0 ||
        o.Return.length !== 0 ||
        o.Fees.Rate !== 0 ||
        o.Fees.Value.Value !== 0
    );
    console.log(json);
    onChange_any("Annual", json);

    // if (e.Init.length !== 0) {
    //     // let path = "Annual[" + i + "]";
    //     // onChange_any(path, e);
    // } else {
    //     // console.log(dataset);
    //     // let path = "Annual[" + i + "]";
    //     // onChange_any(path, e);
    //     let json = data.current.DataSet[client].Annual.slice();
    //     json = json.filter((o) => o.Init.length !== 0 && o.Return.length!==0);
    //     console.log(json);
    //     onChange_any("Annual", json);
    //   }
  };

  const btnClientChanged = (cl) => {
    Update(cl);
  };

  const onChange_t = (e) => {
    onChange_any(e.target.name, e.target.value);
  };
  const onChange_type = (e) => {
    console.log(e)
    console.log(dataset)
    if ((e.target.value === "TFFHSA" || e.target.value === "RESP") && (dataset.InitialYear === undefined || dataset.InitialYear === 0)) {
      console.log("Hmm")
      onChange_any("InitialYear", String(dataset.BirthYear + 0))
    }
    onChange_any(e.target.name, e.target.value);

  }

  const onAdd = () => {
    let n_ann = structuredClone(ann);
    let json = [];
    if (dataset.Annual) {
      json = dataset.Annual.slice();
      n_ann.Id = Math.max(...dataset.Annual.map((o) => o.Id), 0) + 1;
      n_ann.Year = Math.max(...dataset.Annual.map((o) => o.Year), 0) + 1;
    }
    if (n_ann.Year === 1) {
      n_ann.Year = new Date().getFullYear() - 1;
    }
    for (let index = 0; index < dataset.RESPChildren.length; index++) {
      const child = dataset.RESPChildren[index];
      let n_c = structuredClone(ChildCont)
      n_c.ChildName = child.ChildName
      n_ann.Contributions.Child.push(n_c)
    }
    n_ann.Return[0].Type = dataset.Avail.Returns[0];
    n_ann.BirthYear = dataset.BirthYear;
    json.push(n_ann);

    console.log(json);
    onChange_any("Annual", json);
  };

  const onDelete = (e, Id) => {
    console.log(Id)
    let json = dataset.Annual.slice();
    json = json.filter((o) => o.Id !== Id);
    onChange_any("Annual", json);
    setDeleted(true)
  };

  const myError = (obj, i, err) => {
    console.log(obj + i + err)
    console.log(errors)
    errorSet(errors, setErrors, obj, i, err)
    console.log("done myError")
  }

  return (
    <>
      <AddDialog
        clientJson={clientJson}
        c_callback={c_callback}
        onClose={myClose}
        open={show}
        clients={clients}
        client={client}
        label={accountType}
        accountType={accountType}
        subtype={dataset !== undefined && dataset !== null ? dataset.Type : ""}
        onClientChange={btnClientChanged}
        onSubmit={onSubmit}
        errors={errors}
        errmsg={errmsg}
        deleted={deleted}
      >
        {data !== null && dataset !== undefined && dataset !== null && (

          <Stack sx={{ mx: 4 }}>
            <Stack direction="row" spacing={2}>
              <InputName
                key="ds.name"
                value={dataset.Name}
                accountName={true}
                onChange={onChange_t}
                onError={(e) => myError("name", 0, e)}
              />
              {dataset.Avail[accountType] !== undefined &&
                dataset.Avail[accountType] !== null && (
                  < InputButtonGroup
                    label="Account Type"
                    name="Type"
                    value={dataset.Type}
                    buttons={dataset.Avail[accountType]}
                    onChange={onChange_type}
                  />
                )}
              {dataset.Type === "TFFHSA" &&
                (
                  <TFFHSA
                    form={dataset}
                    birthYear={dataset.BirthYear}
                    avail={dataset.Avail}
                    onChange_iy={(e) => { onChange_any("InitialYear", e) }}
                    onChange_ca={(e) => { onChange_any("CloseAccount", e) }}
                    onError={(e) => myError("tffhsa", null, e)}

                  />
                )
              }
              {dataset.Type === "RESP" &&
                (
                  <RESP
                    form={dataset}
                    birthYear={dataset.BirthYear}
                    avail={dataset.Avail}
                    onChange_iy={(e) => { onChange_any("InitialYear", e) }}
                    onChange_ch={(e) => { onChange_any("RESPChildren", e) }}
                    onChange_ca={(e) => { onChange_any("CloseAccount", e) }}
                    onError={(e) => myError("resp", null, e)}

                  />
                )
              }
              {(dataset.Type === "LIRA" || dataset.Type === "DCPP" || dataset.Type === "RRSP") &&
                (
                  <InputAge
                    age={dataset.ConversionAge}
                    label="Convert Age"
                    name="ConversionAge"
                    width={102} // allow space for name and error
                    min={(dataset.Type === "LIRA" || dataset.Type === "DCPP") ? 51 : 55}
                    max={71}
                    form={dataset}
                    tooltip={"Conversion Age for " + ((dataset.Type === "LIRA" || dataset.Type === "DCPP") ? "DCPP/LIRA to LIF" : "RRSP to RIF") + ". Default 0 will be 71"}
                    onChange={(e) => onChange_any(e.target.name, e.target.value)}
                    onError={(e) => myError("conversionage", null, e)}
                    birthYear={dataset.BirthYear}

                  />
                )
              }
              {(dataset.Type === "LIRA" || dataset.Type === "DCPP") &&
                (
                  <LIRA
                    form={dataset}
                    avail={dataset.Avail}
                    onChange_nv={onChange_any}
                    onError={(e) => myError("LIRA", null, e)}
                  />
                )
              }

            </Stack>
            <Stack direction="row" spacing={2}>
              <Stack sx={{ py: 4 }}>
                <CollapseAdd
                  onClick={onAdd}
                  tooltip="Add a new year"
                />
              </Stack>
              <Stack spacing={-3}>
                {Arrayify(dataset.Annual).map((d, i) => (
                  <Stack key={"sd-" + d.Id} direction="row" spacing={2}>
                    <ValueYear
                      avail={dataset.Avail}
                      form={d}
                      minYear={dataset.InitialYear}
                      children={dataset.RESPChildren}
                      onChange={(e) => onChangeMe(e, i)}
                      accountType={accountType}
                      accountTypeSpecific={dataset.Type}
                      onError={(e) => myError("value", i, e)}
                      oneRate={oneRate}
                    />
                    <Stack sx={{ py: 4 }}>
                      <CollapseDelete
                        onClick={(e) => onDelete(e, d.Id)}
                        tooltip="Remove this year"
                      />
                    </Stack>
                  </Stack>
                ))}
              </Stack>
            </Stack>
          </Stack>
        )}
      </AddDialog>
    </>
  );
};

export default AddInvestAccount;
